import { fetcher } from "helpers/fetcher";

import { TGetBUClientMemberReq, TGetBUClientMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUClientMember = async (
  params?: TGetBUClientMemberReq,
  language?: string
) => {
  return await fetcher<TGetBUClientMemberRes, TGetBUClientMemberReq>(
    ENDPOINT.BU.GET_BU_CLIENT_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_CLIENT_MEMBER.version,
        [API_HEADER.BU_ID]: params?.idBu,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetBUClientMember = async (
  params?: TGetBUClientMemberReq,
  language?: string
) => {
  return (await getBUClientMember(params, language)).data;
};

queryGetBUClientMember._key = (
  params?: TGetBUClientMemberReq,
  language?: string
) => [ENDPOINT.BU.GET_BU_CLIENT_MEMBER.url, params, language];
